import React, { useState } from "react";
import { useCart } from "../../components/Client/context/CartContext";
import "./CheckoutPage.css";

const CheckoutPage = () => {
  const { cartItems, clearCart } = useCart();
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    address: "",
    email: "",
    phone: "",
    region: "",
    comuna: "",
    paymentMethod: "Flow",
  });

  const [showAlternateAddress, setShowAlternateAddress] = useState(false);
  const [alternateAddress, setAlternateAddress] = useState({
    name: "",
    surname: "",
    address: "",
    comuna: "",
    region: "",
    notes: "",
  });

  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAlternateInputChange = (e) => {
    const { name, value } = e.target;
    setAlternateAddress({ ...alternateAddress, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Datos del formulario principal:", formData);
    console.log("Dirección alternativa:", alternateAddress);
    console.log("Productos:", cartItems);
    clearCart();
    alert("Pedido realizado con éxito");
  };

  return (
    <div className="checkout-page">
      <div className="checkout-container">
        <form className="checkout-form" onSubmit={handleSubmit}>
          <h2 className="form-title">Detalles de Facturación</h2>
          <div className="form-group">
            <label htmlFor="name">Nombre *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="surname">Apellidos *</label>
            <input
              type="text"
              id="surname"
              name="surname"
              value={formData.surname}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="address">Dirección *</label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Teléfono *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="region">Región *</label>
            <select
              id="region"
              name="region"
              value={formData.region}
              onChange={handleInputChange}
              required
            >
              <option value="">Selecciona una región</option>
              <option value="Region Metropolitana">Región Metropolitana</option>
              <option value="Valparaiso">Valparaíso</option>
              <option value="Concepcion">Concepción</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="comuna">Comuna *</label>
            <input
              type="text"
              id="comuna"
              name="comuna"
              value={formData.comuna}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group-checkbox">
          <input
              id="alternate-address"
              type="checkbox"
              onChange={(e) => setShowAlternateAddress(e.target.checked)}
          />
          <label htmlFor="alternate-address">¿Enviar a una dirección diferente?</label>
          </div>


          {showAlternateAddress && (
            <div className="alternate-address">
              <div className="form-group">
                <label htmlFor="alt-name">Nombre *</label>
                <input
                  type="text"
                  id="alt-name"
                  name="name"
                  value={alternateAddress.name}
                  onChange={handleAlternateInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="alt-surname">Apellidos *</label>
                <input
                  type="text"
                  id="alt-surname"
                  name="surname"
                  value={alternateAddress.surname}
                  onChange={handleAlternateInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="alt-address">Dirección *</label>
                <input
                  type="text"
                  id="alt-address"
                  name="address"
                  value={alternateAddress.address}
                  onChange={handleAlternateInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="alt-region">Región *</label>
                <select
                  id="alt-region"
                  name="region"
                  value={alternateAddress.region}
                  onChange={handleAlternateInputChange}
                  required
                >
                  <option value="">Selecciona una región</option>
                  <option value="Region Metropolitana">
                    Región Metropolitana
                  </option>
                  <option value="Valparaiso">Valparaíso</option>
                  <option value="Concepcion">Concepción</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="alt-comuna">Comuna *</label>
                <input
                  type="text"
                  id="alt-comuna"
                  name="comuna"
                  value={alternateAddress.comuna}
                  onChange={handleAlternateInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="notes">Notas del Pedido (Opcional)</label>
                <textarea
                  id="notes"
                  name="notes"
                  value={alternateAddress.notes}
                  onChange={handleAlternateInputChange}
                />
              </div>
            </div>
          )}
        </form>

        <div className="order-summary">
          <h2>Su Pedido</h2>
          <table>
            <thead>
              <tr>
                <th>Producto</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item) => (
                <tr key={item.id}>
                  <td>
                    {item.name} x {item.quantity}
                  </td>
                  <td>${(item.price * item.quantity).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="order-total">
            <strong>Total:</strong> ${totalPrice.toFixed(2)}
          </div>
          <button type="submit" className="submit-btn">
            Realizar Pedido
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
